import { download } from "../../utils/download";
import systemAlert from "../../utils/systemAlert";
import { crossAjax } from "../../utils/http";
import { toast } from "../../utils/toast";
import { viewLoading } from "../../utils/loading";

export const certProgramName = process.env.REACT_APP_INFOTECH_PROGRAM_FILE_NAME
export const certProgramUrl = process.env.REACT_APP_INFOTECH_PROGRAM_URL

// 인포텍 인증서 프로그램 준비가 되었는지 확인
export const certReady = () => {
  return new Promise((resolve, reject) => {
    crossAjax({
      url: `${certProgramUrl}/?op=setup`,
      success: function (data) {
        if (data.errYn === 'Y') {
          systemAlert(data.errMsg);
          reject(data.errMsg);
          return
        }
        resolve(data);
      },
      error: function (xhr, status, err) {
        systemAlert('인증서 관리 프로그램을 설치해주세요.')
        download(`${window.location.origin}/files/${certProgramName}`, certProgramName)
        reject(err);
      }
    })
  });
}

// 인증서 리스트 불러오기
export const getFinancesCertList = () => {
  return new Promise(async (resolve, reject) => {
    try {
      await certReady()
      crossAjax({
        url: `${certProgramUrl}/?op=certList`,
        success: function (data) {
          if (data.errYn === 'Y') {
            systemAlert(data.errMsg);
            reject(data.errMsg);
            return
          }
          resolve(data.list);
        },
        error: function (xhr, status, err) {
          viewLoading(false)
          systemAlert(`인증서를 가져올수 없습니다 \n ERROR : ${err}`)
          reject(err);
        }
      })
    } catch (error) {
      reject(error);
    }
  });
}

// 인증서 확인
export const getCertResult = (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      await certReady()
      crossAjax({
        url: `${certProgramUrl}/?op=execute`,
        data: JSON.stringify(data),
        success: function (data) {
          if (data.errYn === 'Y') {
            systemAlert(data.errMsg);
            reject(data.errMsg);
            return
          }
          toast.success('인증서 확인되었습니다.')
          resolve(data);
        },
        error: function (xhr, status, err) {
          systemAlert(`인증서정보가 잘못되었습니다. \n ERROR : ${err}`)
          reject(err);
        }
      })
    } catch (error) {
      reject(error);
    }
  });
}